import { TRIGGER_INIT_BANK_DETAILS_API, TRIGGER_INIT_BANK_DETAILS_API_SUCCESS } from 'redux/actionTypes';

export function triggerInitBankDetailsApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_INIT_BANK_DETAILS_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerInitBankDetailsApiCallSuccess(data) {
	return {
		type: TRIGGER_INIT_BANK_DETAILS_API_SUCCESS,
		data,
	};
}
